<template>
    <span>
        <slot
            name="main"
            v-bind:closeModal="closeModal"
            v-bind:openModal="openModal"
            v-bind:showModal="showModal">
        </slot>

        <Teleport to="body">
            <transition name="fade">
                <div v-show="showModal"
                     v-on:click.stop="closeModal">
                    <div class="backdrop-blur-sm bg-black/70 fixed inset-0 w-full h-full z-[1000]"
                         v-on:click.stop="closeModal"></div>
                    <div class="fixed inset-0 overflow-y-auto z-[1001]"
                         v-on:click.stop="closeModal">
                        <div class="flex flex-col h-dvh p-8"
                             v-on:click.stop="closeModal">
                            <div class="flex-grow flex-shrink 2xl:max-h-52"
                                 v-on:click.stop="closeModal"></div>
                            <div class="max-h-full"
                                 v-on:click.stop="closeModal">
                                <div
                                    v-if="$scopedSlots.modal"
                                    class="relative transform overflow-scroll rounded-lg bg-white text-left shadow-xl max-w-full mx-auto max-h-full"
                                    v-bind:class="modalWidthClass"
                                    v-on:click.stop="() => {}">
                                    <svg viewBox="0 0 32 32" fill="none" aria-hidden="true"
                                         class="absolute cursor-pointer h-8 w-8 -right-8 -top-8"
                                         v-if="canClose"
                                         v-on:click="closeModal">
                                        <path
                                            d="m13 13 6 6m0-6-6 6m15-3c0 6.627-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4s12 5.373 12 12Z"
                                            stroke="#CBD5E1" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round"></path>
                                    </svg>
                                    <slot name="modal"
                                          v-bind:closeModal="closeModal"
                                          v-bind:openModal="openModal"
                                          v-bind:showModal="showModal">
                                    </slot>
                                </div>
                                <slot name="modal-out"
                                      v-if="$scopedSlots['modal-out']"
                                      v-bind:closeModal="closeModal"
                                      v-bind:openModal="openModal"
                                      v-bind:showModal="showModal">
                                </slot>
                            </div>
                            <div class="flex-grow flex-shrink"></div>
                        </div>
                    </div>
                </div>
            </transition>
        </Teleport>
    </span>
</template>

<script>
import Teleport from "vue2-teleport";

export default {
    name: "vcs-modal",
    components: {
        Teleport,
    },
    computed: {
        modalWidthClass: function () {
            if (this.modalWidthOverruled)
                return this.modalWidthOverruled;
            return this.modalWidth;
        },
    },
    data: function () {
        return {
            modalWidthOverruled: null,
            showModal: false,
        };
    },
    methods: {
        closeModal: function () {
            // Disable close for unclosable modals
            if (!this.canClose)
                return;

            // Hide modal
            this.showModal = false;
            // document.getElementsByTagName("html")[0].classList.remove('overflow-y-hidden');

            // Remove event listener for escape close
            window.removeEventListener('keydown', this.detectEscape);

            // Emit closed event
            this.$emit('closed');
        },
        openModal: function () {
            this.showModal = true;
            // document.getElementsByTagName("html")[0].classList.add('overflow-y-hidden');

            // Add event listener for escape close
            window.addEventListener('keydown', this.detectEscape);

            // Emit closed event
            this.$emit('opened');
        },
        setModalWidth: function (newWidth) {
            this.modalWidthOverruled = newWidth;
        },
        detectEscape: function (e) {
            if (e.keyCode == '27')
                this.closeModal();
        },
    },
    props: {
        canClose: {
            default: true,
            type: Boolean,
            required: false,
        },
        modalWidth: {
            default: 'sm:max-w-10xl p-4',
            type: String,
            required: false,
        },
        opened: {
            default: false,
            type: Boolean,
            required: false,
        },
    },
    mounted() {
        if (this.opened)
            this.openModal();
    },
}
</script>

<style scoped>
</style>
